<template>
  <div :class="setContainer">
    <v-row justify="space-between" class="header-container">
      <v-col md="6" :cols="12" class="pa-0">
        <div class="pdf-header">PDF File</div></v-col
      >
      <v-col md="6" :cols="12" class="pa-0">
        <div class="tab-header-text text-right">
          <v-btn
            @click="editPDF(null)"
            elevation="0"
            class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
          >
            <v-icon left>mdi-plus</v-icon>
            Add PDF File
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <div v-if="pdfs == null || pdfs.length == 0">
      <v-row class="ma-0" align="center" justify="center">
        <v-icon class="mx-auto" color="#E1E2E6" size="200px"
          >picture_as_pdf</v-icon
        >
      </v-row>
      <v-row class="ma-0" align="center" justify="center">
        <div class="font-weight-bold no-data">ไม่มีไฟล์ให้แสดง</div>
      </v-row>
    </div>

    <div v-show="pdfs !== null && pdfs.length > 0">
      <!-- <v-list two-line subheader>
        <v-list-item v-for="pdf in pdfs" :key="pdf._id" @click="changeStatus(pdf.pdf.url)">
          <v-list-item-avatar>
            <v-icon class="mx-auto" color="black" size="20px">picture_as_pdf</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="pdf.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list> -->

      <div v-for="pdf in listPDF" :key="pdf._id" class="pdf-container">
        <div class="pdf-icon" @click="changeStatus(pdf.url)">
          <v-icon size="24">mdi-file-pdf</v-icon>
        </div>
        <div class="pdf-action">
          <!-- <v-icon>mdi-dots-horizontal</v-icon> -->
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-horizontal</v-icon>
              </div>
            </template>
            <v-list>
              <v-list-item @click="editPDF(pdf)">
                <v-list-item-icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Edit</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="deleteDialog(pdf._id)">
                <v-list-item-icon>
                  <v-icon>mdi-trash-can</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <div class="pdf-detail" @click="changeStatus(pdf.url)">
          <v-row class="ma-0">
            <span class="pdf-name">{{ pdf.title }}</span>
          </v-row>
        </div>
      </div>

      <v-pagination
        v-model="currentPage"
        class="pagination-align-right justify-flex-end"
        :length="totalPDF"
      ></v-pagination>

      <div class="notification-container dismiss styleCard">
        <div class="pa-2 btnBack" @click="goBack">
          <v-icon class="mx-auto px-2" color="black" size="20px"
            >mdi-arrow-left</v-icon
          >Back
        </div>
        <iframe :class="setIframe" :src="pdfShow"></iframe>
      </div>
    </div>
    <InsertPdfDialog
      :isDialogOpen.sync="openEditDialog"
      :closeDialog.sync="closeDialog"
      :liveId.sync="liveId"
      :pdfDetail.sync="pdfDetail"
      :total.sync="pdfs.length"
    />
    <v-dialog v-model="deleteDialogStatus" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertDeleteLesson'
          )
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.live.alertDeletePDFCantBringData'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            class="px-9 ma-2 font-weight-light"
            dark
            outlined
            @click="closeDeleteDialog"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.cancel')
            }}</v-btn
          >
          <v-btn
            class="px-10 ma-2 font-weight-light"
            color="error darken-1"
            dark
            @click="deleteUrlById"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import $ from 'jquery';
// import pdf from 'vue-pdf';
import InsertPdfDialog from '@/components/live/dialog/insertPDFDialog';
import { getListPdf, deletePdf } from '@/service/course/livev2.js';
export default {
  data() {
    return {
      showPDF: false,
      pdfShow: '',
      setbool: false,
      setContainer: '',
      setIframe: '',
      pdfs: [],
      openEditDialog: false,
    deleteDialogStatus: false,
    deleteId: null,
    sizePerPage: 5,
    currentPage: 1,
    };
  },
  props: {
    liveId: {
      type: String,
    },
  },
  components: {
    // pdf
    InsertPdfDialog,
  },
  computed: {
    listPDF() {
      const start = (this.currentPage - 1) * this.sizePerPage,
        end = start + this.sizePerPage;
      let data = this.pdfs;
      return data.slice(start, end);
    },
    totalPDF() {
      let l = this.pdfs.length,
        s = this.sizePerPage;
      return Math.ceil(l / s);
    },
  },
  async mounted() {
    this.initialize();
  },
  methods: {
    async initialize() {
      let result = await getListPdf(this.liveId);
      this.pdfs = result;
    },
    
    async deleteDialog(id) {
      this.deleteDialogStatus = true;
      this.deleteId = id;
    },
    async deleteUrlById() {
      let result = await deletePdf(this.liveId, this.deleteId);
      await this.closeDeleteDialog();
    },
    async closeDeleteDialog() {
      this.deleteDialogStatus = false;
      await this.initialize();
    },
    async editPDF(detail) {
      this.openEditDialog = true;
      this.pdfDetail = detail;
    },
    goBack() {
      this.setbool = false;
      this.setContainer = 'unSetHeightContainer';
      this.setIframe = 'iframePDFLive';
      if ($('.notification-container').hasClass('selected')) {
        $('.notification-container')
          .removeClass('selected')
          .addClass('dismiss');
      }
    },
    async closeDialog() {
      this.openEditDialog = false;
      await this.initialize();
    },
    changeStatus(url) {
      this.setContainer = 'setHeightContainer';
      this.setIframe = 'iframePDFLive';
      this.setbool = true;
      this.pdfShow = url;
      if ($('.notification-container').hasClass('dismiss')) {
        $('.notification-container')
          .removeClass('dismiss')
          .addClass('selected')
          .show();
      }
    },

    openNewWeb(url) {
      window.open(
        url,
        'vuetifyjs',
        'resizable,scrollbars,status,width=1000,height=700'
      );
    },
  },
};
</script>
<style lang="scss"  scoped>
.btnBack:hover {
  cursor: pointer;
}

.styleCard {
  border-radius: 0px !important;
}
.description {
  font-size: 16px;
}
.no-data {
  color: #e1e2e6;
}
.chat-avatar {
  padding: 10px 10px 10px 0px;
  display: inline-table;
}
.chat-message {
  padding: 10px;
  display: inline-table;
  font-size: 16px;
  /* width: 50px; */
}
.box-disable {
  background-color: #f4f4f4;
  vertical-align: center;
  width: 100%;
  height: 100%;
  margin: auto;
  /* width: 60%; */
  /* border: 3px solid #73AD21; */
  padding: 6px;
}
.white-text-btn {
  color: white;
}
.notification-container {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  /* display: none; */
  height: 100%;
  overflow: hidden;
  background: white;
  z-index: 999;
  transform: translateX(100%);
  -webkit-transform: translateX(100%);
}
.selected {
  display: block;
  animation: slide-in 0.3s forwards;
  -webkit-animation: slide-in 0.3s forwards;
}
.dismiss {
  animation: slide-out 0.3s forwards;
  -webkit-animation: slide-out 0.3s forwards;
  z-index: 0;
  /* display: none; */
}
@media only screen and (max-width: 600px) {
  .setHeightContainer {
    min-height: 500px;
  }
  .unSetHeightContainer {
    min-height: unset !important;
  }
  .iframePDFLive {
    width: 100%;
    min-height: 450px;
  }
}
@media only screen and (min-width: 601px) and (max-width: 960px) {
  .setHeightContainer {
    min-height: 900px;
  }
  .unSetHeightContainer {
    min-height: unset !important;
  }
  .iframePDFLive {
    width: 100%;
    min-height: 850px;
  }
}
@media only screen and (min-width: 961px) {
  .setHeightContainer {
    min-height: 1000px;
  }
  .unSetHeightContainer {
    min-height: unset !important;
  }
  .iframePDFLive {
    width: 100%;
    min-height: 950px;
  }
}

.pdf-header {
  font-size: 26px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}
.pdf-name {
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}
.pdf-container {
  border-radius: 4px;
  background-color: #f7f7f7;
  padding: 20px;
  margin-bottom: 10px;
  width: 100%;
}
.header-container {
  margin: 0px;
  margin-bottom: 30px;
}
.pdf-icon {
  float: left;
  width: 37px;
  cursor: pointer;
}
.pdf-action {
  float: right;
  width: 37px;
  align-self: center;
}
.pdf-detail {
  margin: 0 auto;
  width: calc(100% - 37px - 37px);
  line-break: anywhere;
  cursor: pointer;
}
.pagination-align-right {
  justify-content: flex-end;
  padding-top: 15px;
}
</style>

<style lang="scss">
.pdf-icon {
  .v-icon {
    vertical-align: baseline;
    line-height: 0;
  }
}
.pdf-action {
  .v-icon {
    vertical-align: baseline;
    line-height: 0;
  }
}
.pagination-align-right {
  .v-pagination__item--active {
    background-color: #308ab7 !important;
    border-color: #308ab7 !important;
  }
}
.pagination-align-right.justify-flex-end {
  .v-pagination.theme--light {
    justify-content: flex-end;
  }
}
</style>